<template>
  <svg width="32"
       height="32"
       viewBox="0 0 32 32"
       fill="none"
       xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_8503_56093)">
      <g clip-path="url(#clip1_8503_56093)">
        <rect x="2"
              y="2"
              width="28"
              height="28"
              rx="3.6"
              fill="url(#paint0_linear_8503_56093)"
        />
        <rect x="2"
              y="2"
              width="28"
              height="28"
              rx="3.6"
              fill="url(#paint1_radial_8503_56093)"
        />
        <rect x="2"
              y="2"
              width="28"
              height="28"
              rx="3.6"
              fill="url(#paint2_radial_8503_56093)"
        />
        <rect x="2"
              y="2"
              width="28"
              height="28"
              rx="3.6"
              fill="url(#paint3_linear_8503_56093)"
        />
        <rect x="2"
              y="2"
              width="28"
              height="28"
              rx="3.6"
              fill="url(#paint4_linear_8503_56093)"
        />
        <rect x="2"
              y="2"
              width="28"
              height="28"
              rx="3.6"
              fill="url(#paint5_linear_8503_56093)"
        />
        <rect x="2"
              y="2"
              width="28"
              height="28"
              rx="3.6"
              fill="url(#paint6_linear_8503_56093)"
        />
        <path d="M13.4759 23.25C13.0927 23.25 12.7095 23.1066 12.4169 22.8192L6.67244 17.1778C6.0877 16.6035 6.0877 15.672 6.67244 15.0977C7.25718 14.5235 8.20574 14.5235 8.79048 15.0977L13.4058 19.6303C13.4447 19.6685 13.507 19.6685 13.5459 19.6303L23.6773 9.68069C24.262 9.10644 25.2106 9.10644 25.7953 9.68069C26.3801 10.2549 26.3801 11.1865 25.7953 11.7607L14.5349 22.8192C14.2428 23.1066 13.859 23.25 13.4759 23.25Z"
              fill="#FCF2FF"
        />
      </g>
    </g>
    <defs>
      <linearGradient id="paint0_linear_8503_56093"
                      x1="16"
                      y1="2"
                      x2="16"
                      y2="30"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#59D88F" />
        <stop offset="1"
              stop-color="#55CE89"
        />
      </linearGradient>
      <radialGradient id="paint1_radial_8503_56093"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(28.5 3.5) rotate(135) scale(3.53553 4.12942)"
      >
        <stop stop-color="#6FF4A4"
              stop-opacity="0.6"
        />
        <stop offset="1"
              stop-color="#6FF4A4"
              stop-opacity="0"
        />
      </radialGradient>
      <radialGradient id="paint2_radial_8503_56093"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(3 29) rotate(-40.6013) scale(4.60977 5.3841)"
      >
        <stop stop-color="#388964"
              stop-opacity="0.7"
        />
        <stop offset="1"
              stop-color="#388964"
              stop-opacity="0"
        />
      </radialGradient>
      <linearGradient id="paint3_linear_8503_56093"
                      x1="30"
                      y1="16"
                      x2="25.5"
                      y2="16"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#6FF4A4"
              stop-opacity="0"
        />
        <stop offset="0.479167"
              stop-color="#6FF4A4"
              stop-opacity="0.3"
        />
        <stop offset="1"
              stop-color="#6FF4A4"
              stop-opacity="0"
        />
      </linearGradient>
      <linearGradient id="paint4_linear_8503_56093"
                      x1="16"
                      y1="2"
                      x2="16"
                      y2="6"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#6FF4A4"
              stop-opacity="0"
        />
        <stop offset="0.479167"
              stop-color="#6FF4A4"
              stop-opacity="0.4"
        />
        <stop offset="1"
              stop-color="#6FF4A4"
              stop-opacity="0"
        />
      </linearGradient>
      <linearGradient id="paint5_linear_8503_56093"
                      x1="16"
                      y1="2"
                      x2="16"
                      y2="30"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#388964"
              stop-opacity="0.35"
        />
        <stop offset="0.058296"
              stop-color="#388964"
              stop-opacity="0"
        />
        <stop offset="0.872197"
              stop-color="#388964"
              stop-opacity="0"
        />
        <stop offset="0.939462"
              stop-color="#388964"
              stop-opacity="0.438597"
        />
        <stop offset="1"
              stop-color="#388964"
        />
      </linearGradient>
      <linearGradient id="paint6_linear_8503_56093"
                      x1="29.9012"
                      y1="15.7489"
                      x2="2.27791"
                      y2="15.7489"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#388964"
              stop-opacity="0.35"
        />
        <stop offset="0.058296"
              stop-color="#388964"
              stop-opacity="0"
        />
        <stop offset="0.872197"
              stop-color="#388964"
              stop-opacity="0"
        />
        <stop offset="0.939462"
              stop-color="#388964"
              stop-opacity="0.438597"
        />
        <stop offset="1"
              stop-color="#388964"
        />
      </linearGradient>
      <clipPath id="clip0_8503_56093">
        <rect width="32"
              height="32"
              fill="#FFFFFF"
        />
      </clipPath>
      <clipPath id="clip1_8503_56093">
        <rect width="32"
              height="32"
              fill="#FFFFFF"
        />
      </clipPath>
    </defs>
  </svg>
</template>
